import React, { useEffect, useState } from "react";
import generatePDF from "./generatePDF";
import { mainApi } from "../../../services/api";
import TicketsComponent from "./TicketsComponent"
const Tickets = () => {
  
  const [tickets, setTickets] = useState([]);
  const user="user";

  useEffect(() => {
    const getAllTickets = async () => {
      
      try {
        const response = await mainApi.get("users");
        setTickets(response.data.users);
      } catch (err) {
        console.log("error");
      }
    };
    getAllTickets();
  }, []);

const reportTickets = tickets&&tickets.filter(ticket => ticket.user_role_id === "4");
  
  return (
    <div className="page-content">
      <div className="container mb-4 mt-4 p-3">
        <div className="row">
         
            <button
              className="btn btn-primary"
              onClick={() => generatePDF(reportTickets)}
            >
              Generate monthly report
            </button>
         
        </div>
      </div>
      <TicketsComponent tickets={tickets} />
    </div>
  );
};

export default Tickets;